import { render } from "./SiteLoader.vue?vue&type=template&id=62d80042&scoped=true"
import script from "./SiteLoader.vue?vue&type=script&lang=js"
export * from "./SiteLoader.vue?vue&type=script&lang=js"

import "./SiteLoader.vue?vue&type=style&index=0&id=62d80042&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62d80042"]])

export default __exports__